import React, { useState, useEffect,useRef,useCallback, useMemo  } from 'react'
import { Link } from 'react-router-dom'
import styles from '../layout/Home.Module.css'
import  '../layout/LanguageSelect.Module.css'
import  '../layout/UpcomingEvent.Module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight,faPlus,faLightbulb } from '@fortawesome/free-solid-svg-icons'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { cardImageSlide } from '../card-slide';
import Slider from 'react-slick'
import { news } from '../noticias';
import $ from 'jquery'
import axios from 'axios';
import LoginModal from './LoginModal'
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { upcomingEvent } from '../upcomingEvent'
import { useAuth } from './AuthContext';
import { destaque } from '../emdestaque'; 
import {fetchRecommendedProducts } from '../api';
import { useLanguage } from './LanguageContext';
import {addToRecentView } from './ProdDetail';
import CountDown from './hooks/CountDown'
import ProductCard from './ProductCard';
import { useCampanhas } from './hooks/useCampanhas'
import VanillaTilt from "vanilla-tilt";
import TiltCard from './hooks/TiltCard'
import useScrollReveal from './hooks/useScrollReveal'
import useGoogleTranslateRefresh from './hooks/useGoogleTranslateRefresh';

const Home = ({}) => {
const { campanhas} = useCampanhas();
const observerRef = useRef(null);
const tiltRef = useRef(null);
const [visibleIndexes, setVisibleIndexes] = useState([0, 1, 2, 3]);
const location = useLocation();
const { user, toggleFavorite, hasLoggedIn} = useAuth()
/************Change Login/Register modal**********/
const [login, setLogin] = useState(false);
const [register, setRegister] = useState(false);

const loginClose = () => setLogin(false);
const loginShow = () => setLogin(true);

const registerClose = () => setRegister(false);
const registerShow = () => setRegister(true);

const changeModal=()=>{
  loginClose();
  registerShow();
}

const changeToLogin=()=>{
  registerClose();
  loginShow();
}
/**************MYSQL database****************** */
const { t, i18n } = useTranslation();
const [translatedProducts, setTranslatedProducts] = useState([]);
const { selectedLanguage } = useLanguage();

const [newProdus, setnewProds] = useState([]);
useEffect(() => {
  const fetchProducts = async () => {
    try {
      const response = await fetch(`https://advancelighting.pt/campanha.php` );
      const data = await response.json();
      const processedData = Array.isArray(data)  ? data.map(product => ({
            ...product,
            // 💡CONVERSÃO: Garante que pvp seja um número (ou null se inválido)
            pvp: product.pvp ? parseFloat(product.pvp) : null,})) : [];
      setnewProds(processedData); // Agora já vêm traduzidos do backend!
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
    }
  };
  fetchProducts();
}, []);

const [activeIndex, setActiveIndex] = useState(0);
const listRef = useRef(null);
const thumbnailsRef = useRef(null);
const countItem = cardImageSlide.length;

const showSlider = (newIndex) => {
  setActiveIndex(newIndex);
};

// Altere as funções de navegação para usar o estado anterior (prev)
const nextSlide = () => {
  setActiveIndex((prev) => (prev + 1 >= countItem ? 0 : prev + 1));
};

const prevSlide = () => {
  setActiveIndex((prev) => (prev - 1 < 0 ? countItem - 1 : prev - 1));
};

const handleThumbnailClick = (index) => {
  showSlider(index);
};

useEffect(() => {
  const intervalId = setInterval(nextSlide, 10000);
  return () => clearInterval(intervalId);
}, []);

const createSliderSettings = ({
  autoplay = true,
  dots = true,
  slidesToShow = 5,
  slidesToScroll = 5,
  initialSlide = 0,
  responsiveOverrides = []
} = {}) => ({
  autoplay,
  dots,
  slidesToShow,
  slidesToScroll,
  initialSlide,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: Math.min(slidesToShow, 4),
        slidesToScroll: Math.min(slidesToScroll, 4),
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: Math.min(slidesToShow, 3),
        slidesToScroll: Math.min(slidesToScroll, 3),
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: Math.min(slidesToShow, 3),
        slidesToScroll: Math.min(slidesToScroll, 3),
        initialSlide: 2,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: Math.min(slidesToShow, 3),
        slidesToScroll: Math.min(slidesToScroll, 3),
        initialSlide: 1,
        dots: false
      }
    },
    ...responsiveOverrides // Permite adicionar configurações específicas
  ]
});

const handleAfterChange = (currentIndex) => {
  setVisibleIndexes([currentIndex, currentIndex + 1, currentIndex + 2, currentIndex + 3]);
};

// Exemplo de uso
const settings = createSliderSettings({});
const newProds = createSliderSettings({
  autoplay: true,
  dots: false,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsiveOverrides: [
    {
      breakpoint: 380,
      settings: {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 1
      }
    }
  ]
});

const destaques = createSliderSettings({
  autoplay: false,
  slidesToShow: 10,
  slidesToScroll: 10,
  responsiveOverrides: [
    {
      breakpoint: 380,
      settings: {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 1
      }
    }
  ]
});
/**********************************Produtos em destaque************************************************/
const [recommendedProducts, setRecommendedProducts] = useState([]);
const [currentHighlightIndex, setCurrentHighlightIndex] = useState(0); // Índice do destaque atual

const changeHighlight = useCallback((direction) => {
  const nextIndex = (currentHighlightIndex + direction + destaque.length) % destaque.length;
  setCurrentHighlightIndex(nextIndex);
}, [currentHighlightIndex, destaque.length]);

// Dados do destaque atual
const currentHighlight = useMemo(() => {
  if (!destaque || destaque.length === 0) {
    return { products: [] };
  }

  return {
    ...destaque[currentHighlightIndex],
    products: destaque[currentHighlightIndex]?.products ?? [],
  };
}, [currentHighlightIndex, destaque]);

useEffect(() => {
  if (currentHighlight.products.length === 0) {
    setRecommendedProducts([]); // limpa os produtos quando não houver
    return;
  }

  fetchRecommendedProducts(currentHighlight.products)
    .then((prod) => setRecommendedProducts(prod))
    .catch((err) =>
      console.error("Erro ao carregar produtos recomendados:", err)
    );
}, [currentHighlight]);

// Ordenar os produtos recomendados de acordo com a lista de IDs no destaque
const sortedProducts = useMemo(() => {
  return recommendedProducts
    .sort((a, b) => currentHighlight.products.indexOf(a.idP) - currentHighlight.products.indexOf(b.idP)); // Ordena conforme os IDs no destaque
}, [recommendedProducts, currentHighlight]);

const videoSrc = currentHighlight.video;
const title = currentHighlight.title[i18n.language]; 
const text = currentHighlight.text?.[i18n.language];
const productName = currentHighlight.productName?.[i18n.language];
const iframeRef = useRef(null);
useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && iframeRef.current) {
        iframeRef.current.src = videoSrc;
      }
    },
    { threshold: 0.25 }
  );
  if (iframeRef.current) observer.observe(iframeRef.current);

  return () => observer.disconnect();
}, [videoSrc]);

  const navigate = useNavigate();
  const GotToNewPage =(name,id)=>{
    if (typeof name !== 'string' || !name.trim()) {
      return;
    }
    const url = `/prodetail/${encodeURIComponent(name.replace(/\s+/g, '-').toLowerCase())}/${id}`;
    window.open(url, '_blank');
  }
  useEffect(() => {
    // Atualiza o src do iframe sem desmontar o componente
    if (iframeRef.current) { iframeRef.current.src = `${videoSrc}?autoplay=1&mute=1`;
    }
  }, [videoSrc]);

  const twoFunctions =(name,id)=>{
    addToRecentView(id)
    GotToNewPage(name,id)
  }


const countersRef = useRef([]);
useEffect(() => {
  const counters = countersRef.current;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = +el.dataset.number;
          let start = 0;

          const increment = target / 100;
          const updateCounter = () => {
            start += increment;
            if (start < target) {
              el.innerText = Math.floor(start);
              requestAnimationFrame(updateCounter);
            } else {
              el.innerText = target;
            }
          };

          updateCounter();
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.5 }
  );

  counters.forEach((counter) => {
    if (counter) observer.observe(counter);
  });

  return () => observer.disconnect();
}, []);

const handleRedirect = (categoryId) => {
    const query = categoryId; // Junta os IDs em uma string separada por vírgulas
    navigate(`/area?ids=${query}`);
};

  const isMobile = window.innerWidth < 1024;
  const handleClick = () => {
  // Define função global para ativar o popup
  if (window.abrirPopupCampanhas) {
    window.abrirPopupCampanhas();
  }
  };
const parseDate = (dateString) => {
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day);
};

// 1. FILTRAR E FORMATAR EVENTOS FUTUROS
const today = new Date();
today.setHours(0, 0, 0, 0); 

  return (
    <div className='homepage' style={styles}>
      <div className="slider">
        <div className='slogan'>ADVANCED LIGHTING SOLUTIONS</div>

        <div className="list" ref={listRef}>
        {cardImageSlide.map((item, index) => {
            // Trata o título: se é um objeto de tradução (produto) ou string (evento)
            const title = item.isEvent ? item.bigtitle : item.bigtitle?.[i18n.language];
            const description = item.text?.[i18n.language];
            return (
                <div className={`item ${index === activeIndex ? "active" : ""}`} key={item.id}>
                <img src={item.linkImg} alt={item.cardTitle}/>
                <div className={`content ${item.isEvent ? 'event-content' : ''}`}>
                  {item.isEvent ? 
                  <>
                  <div className='text-logo'>
                   <img className='logo' src={item.logoBR} /> 
                    <h2 className='main-title'>2025</h2>
                  </div>
                  </>: <h2 className='main-title'>{title}</h2>}
                  {item.isEvent ? null : <p className='descri'>{description}</p>}
                  {/* O bloco de detalhes do evento permanece aqui */}
                  {item.isEvent &&
                    <div className="event-location">
                        {/* Nota: Lembre-se que item.country e item.city precisam ser traduzidos se você formatar o texto aqui */}
                        <span className="event-badge"><span>{t('eventos.matelecIntro')}</span></span>
                      <div className="event-link mt-3">
                        <Link to='evento/Matelec%202025' className="">{t('homepage.verMais')}</Link>
                      </div>
                    </div>
                  }
                </div>
                </div>
            );
        })}
        </div>
        <div className="arrows">
            <button id="prev" onClick={prevSlide}><FontAwesomeIcon icon={faChevronLeft} /></button>
            <button id="next" onClick={nextSlide}><FontAwesomeIcon icon={faChevronRight} /></button>
        </div>

      <div className="thumbnail" ref={thumbnailsRef}>
        {cardImageSlide.map((item, index) => {
            const title = item.isEvent ? item.bigtitle: item.bigtitle?.[i18n.language];   
            return (
             <div className={`item ${index === activeIndex ? "active" : ""}`} key={item.id} 
              onClick={() => handleThumbnailClick(index)} >
              <img src={item.linkImg} alt={item.cardTitle}/>
              <div className="content"> <a> {title} </a> </div>
             </div>
            );
        })}
      </div>

    <section className="list section gamateste">
      <div className='listagama'>
        {cardImageSlide.map((item, index) => {
            const title = item.isEvent ? item.bigtitle  : item.bigtitle?.[i18n.language]; 
            const linkTitle = item.isEvent ? t('Ver detalhes do evento') : t('Ver gama de produtos');
          return item.isEvent ? null :
          <div className={`item ${index === activeIndex ? "active" : null}`} key={item.id}>
                <Link to={title} className="bb_button">
                    <span className="bb_button__text bg" title={linkTitle}>
                        {t('homepage.verMais')}
                    </span>
                </Link>
          </div>;
        })}
      </div>
    </section>

  {user && campanhas.length > 0 && (
    <div className="container-campanhas" onClick={handleClick}>
    <button className="botao-circular">
      <i className="fas fa-bullhorn" size="5x"></i>
    </button>

    <svg viewBox="0 0 100 100" className="svg-circular desktop">
      <defs>
        <path id="circlePath" d="M50,50 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" />
      </defs>
      <text className="texto-animado">
        <textPath href="#circlePath" startOffset="0%">
         {t('homepage.campanhasButton')}
        </textPath>
      </text>
    </svg>

    <svg viewBox="0 0 100 100" className="svg-circular mobile">
      <defs>
        <path id="circlePathMobile" d="M50,50 m-39,0 a39,39 0 1,1 78,0 a39,39 0 1,1 -78,0" />
      </defs>
      <text className="texto-animado">
        <textPath href="#circlePathMobile" startOffset="0%">
         {t('homepage.campanhasButton')}
        </textPath>
      </text>
    </svg>
  </div>
)}
</div>

<div className='categories'>
<h2 className='title text-center' >{t('homepage.novidades')}</h2>
  {/*Link para redirecionar para a página de produtos filtrada por categoria com marca*/}
<div className='row novidades mt-2'>
{newProdus.length > 6 ? (
  <Slider {...newProds}>
    {newProdus.map((resu,index) => { 
      return (
        <div className="col-sm-6 col-md-2" key={index} onClick={() => twoFunctions(resu.nome, resu.idP)}>
        <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
        </div>
      );
    })}
  </Slider>
) : (
  newProdus.map((resu) => {
    return (
      <div className="col-sm-6 col-md-2" key={resu.idP} onClick={() => twoFunctions(resu.nome, resu.idP)}>
      <div className="shop__thumb">
        <h6 className='novidades-button'>{t('pdetail.novo')}</h6>
        <Link to={`/prodetail/${encodeURIComponent(resu.originalName.replace(/\s+/g, '-').toLowerCase())}/${resu.id}`} target="_blank" onClick={twoFunctions(resu.id)}>
          <div className="shop-thumb__img">
            <img src={resu.imgP} className="img-responsive" alt="..." />
          </div>
          <h3 className="shop-thumb__title pnome"><b>{resu.name}</b></h3>
          <h5 className="shop-thumb-brand b-name">{resu.marca}</h5>
          <h5 className="shop-thumb-brand ref-pvp" >
          <div className='ref-block'>
              <span className="references">Ref:</span>&nbsp;
              <span className="product-reference">
              {resu.refs}
                  </span>
              {resu?.pvp_status == 'Sob-consulta' && (<span className="shop-thumb-brand second-block"><span className="no-bold">IP {resu.pvp_status}</span> </span>)}
            </div>
            <div className='pvp-text'>
                <span className="references">P.V.P.</span>
            </div>
            </h5>
          <div className="ip-pvp-container">
          {resu?.ip != null && (
            <span className="shop-thumb-brand second-block">
              <span className="no-bold">IP {resu.ip}</span>
            </span>
          )}
          <span className="pvp-value">{resu.pvp ? parseFloat(resu.pvp).toFixed(2) + "€" : ""}</span>
        </div>
        </Link>

      </div>
    </div>
    );
  })
)}
</div>
</div>

<section className='video'>
  <h2 className='title text-center'>{t('homepage.titleDestaque')}</h2>
  <div className='content-box'>
  <div className="text-box">
  {productName && <h3 className="product-name">{productName}</h3>}
    <h2 className="title-text text-capitalize">{title}</h2>
    <p>{text}</p>

  <div className="list-magne-imgs">
 {sortedProducts?.length > 0 && sortedProducts.map((prod, index) => {
  if (!prod || !prod.name) return null; // ignora produtos inválidos
  return (
    <Link to={`/prodetail/${encodeURIComponent(prod.name?.replace(/\s+/g, "-").toLowerCase())}/${prod.id}`} className="magnetic-sample"  key={index}>
        <div className="magne-img">
          <img loading="lazy" src={prod.imgP} alt={prod.name} width="200" height="200" />
          <span className='translate'>{prod.name}</span>
          {prod?.dc != null && <h6>{prod.dc} Volts</h6>}
          {prod?.w != null && <h6>{prod.w} watts</h6>}
        </div>
      {/* conteúdo */}
    </Link>
  )
})}
  </div>
</div>
  {/* Vídeo principal */}
  <iframe ref={iframeRef}  muted id="video" width="100%"height="100%" allow="autoplay; encrypted-media" src={`${destaque[currentHighlightIndex].video}?autoplay=1&muted=1`} title={destaque[currentHighlightIndex].title.pt}></iframe>
</div>

  <div className="video-grid">
  <Slider {...destaques}>
    {destaque.map((highlight, index) => (
        <div
        key={highlight.id}
        className={`grid-item ${index === currentHighlightIndex ? "active" : ""}`}
        onClick={() => setCurrentHighlightIndex(index)}>
        {/* Exibir uma imagem em vez do vídeo */}
        <img  src={`https://img.youtube.com/vi/${highlight.video.split("/embed/")[1]}/0.jpg`}
        alt={highlight.title.pt} width="100%"loading="lazy"  />
        <p className="grid-item-title">{highlight.title[i18n.language]}</p>
      </div>
    ))}
  </Slider>
  </div>
</section>

<div className='info-company'>
  <div className='info-adv-box'>
      <div className='info-item'>
      <img src = "./images/icones/factory1.svg" alt="factory"/>
        <h4 className='text'>+ <span className='counterUp' data-number="8000" ref={(el) => (countersRef.current[0] = el)}>0</span> m2</h4>
      </div>
      <div className='info-item' >
      <img src = "./images/icones/staff1.svg" alt="team"/>
        <h4 className='text'>+ <span className='counterUp' data-number="50" ref={(el) => (countersRef.current[1] = el)}>0</span> staff</h4>
      </div>
      <div className='info-item'>
        <img src = "./images/icones/prod1.svg" alt="prod"/>
        <h4 className='text'>+ <span className='counterUp' data-number="3000" ref={(el) => (countersRef.current[2] = el)}>0</span> products</h4>
      </div>
      <div className='info-item'>
        <img src = "./images/icones/positive1.svg" alt="positive grown"/>
        <h4 className='text'>{t('homepage.cresci')}</h4>
      </div>
  </div>

</div>
<div className='brands'>
  <h2 className='text-center'></h2>
</div>

<div className='news'>
<section className="blog">
  <div className="container">
    <div className="blog-head text-center">
      <h2 className='title text-center'>{t('homepage.titleNoticias')}</h2>
      <Link to="/noticias" className='underline-linkNews'>{t('homepage.verMais')} +</Link>
    </div>
    {/* trocar pelas notícias da lista*/}
    <div className="grid-news">
      {news.map((n,index)=>{
        if(index <= 2) return(
          <div className="news-item" key={index} >
            <div className="item">
              <div className="img">
                <img src={n.imgP} alt="" />
              </div>
              <div className="info">
                <Link to={`/noticia/${n.id}`} onClick={()=>{window.scroll(0,0);}}><h6>{n.title[selectedLanguage]}</h6></Link>
                <p className='news-descri'>{n.descri[selectedLanguage]}</p>
                <Link className="user" to={`/noticia/${n.id}`} onClick={()=>{window.scroll(0,0); }}>
                <FontAwesomeIcon icon={faPlus} />{t('homepage.verMais')}</Link>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  </div>
</section>
</div>

<LoginModal login={login} 
    loginClose={loginClose} 
    loginShow={loginShow}
    register={register}
    registerClose={registerClose}
    registerShow={registerShow}
    changeModal={changeModal}
    changeToLogin={changeToLogin}/>
</div>
  )
}
export default Home
